const { times } = require("ramda");

angular.module("ticketco/ticketbuyer/time_slots")
  .component("timeSlotsMobileOrderForm", {
    templateUrl: "timeSlotsMobileOrderFormComponent.html",
    bindings: {
      onSelect: "&",
      promocode: "<",
    },
    controller: function controller(TimeSlotsModel) {
      var self = this;
      var selectedItemTypesDestructor;
      self.itemTypes = [];

      self.$onInit = function onInit() {
        selectedItemTypesDestructor = TimeSlotsModel.getSelectedItemTypes(function (_, itemTypes) {
          self.itemTypes = itemTypes;
        });
      };

      self.$onDestroy = function onDestroy() {
        selectedItemTypesDestructor();
      };

      self.onClick = function onSelect(itemType) {
        self.onSelect({
          $selected: itemType,
        });
      };

      self.range = function (max) {
        return times(function (i) {
          return i;
        }, max + 1);
      };

      self.min = Math.min;
    },
  });
